import { redirect } from './browser';
import mediator from './mediator';
import { removeSessionObject } from './storage';
import { store } from './store';

// The registration-specific name remains supported for existing callers and saved sessions.
export const getStandaloneReturnUri = env => env.standalone_return_uri ?? env.registration_return_uri;

// Keep basic URL validation for HTTP(S) and root-relative destinations.
export const getStandaloneReturnUrl = returnUri => /^(https?:\/\/|\/(?!\/))/i.test(returnUri) ? returnUri : undefined;
export const exitStandaloneFlow = () => {
  const returnUri = getStandaloneReturnUri(store.getState().env);
  const exitUrl = returnUri ? getStandaloneReturnUrl(returnUri) : undefined;
  if (!exitUrl) {
    mediator.publish('router:navigate', '/auth-error');
    return;
  }
  removeSessionObject('authSession');
  removeSessionObject('env');
  removeSessionObject('config');
  redirect(exitUrl);
};